export default {"src":"/_next/static/media/helloeroRed.e34c8751.svg","height":116,"width":401,"blurWidth":0,"blurHeight":0};